import React, { useEffect } from 'react';
import { MeasureEpisodeIcon } from '@cdl/heartbeat-react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeEpisodeMeasurement } from '../thunks/initialize-episode-measurement.thunk';
import { setActiveTool } from '../../tool/actions/tool.actions';
import { isToolActiveSelector } from '../../tool/selectors/tool.selectors';
import { Tool } from '../../tool/utils/tool.utils';
import { useParentOnsetsSelector } from '../../scatter/selectors/scatter.selectors';
import { trackStopEpisodeMeasurement } from '../../analytics/thunks/track-stop-episode-measurement.thunk';
import { trackEpisodeMeasurement } from '../../analytics/thunks/track-episode-measurement.thunk';
import { ToolButton } from '../../../features/tool/components/ToolButton';

export const EpisodeMeasurementTool: React.FC = () => {
  const dispatch = useDispatch();
  const isEpisodeMeasurementActive = useSelector(
    isToolActiveSelector(Tool.episodeMeasurement),
  );

  const isParentHolterView = useSelector(useParentOnsetsSelector);

  useEffect(() => {
    if (isParentHolterView && isEpisodeMeasurementActive) {
      dispatch(
        setActiveTool({
          tool: null,
          meta: { history: false },
        }),
      );
    }
  }, [isParentHolterView, isEpisodeMeasurementActive, dispatch]);

  useEffect(() => {
    return () => {
      if (isEpisodeMeasurementActive) {
        dispatch(
          setActiveTool({
            tool: null,
            meta: { history: false },
          }),
        );
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activateEpisodeMeasurement = () => {
    dispatch(initializeEpisodeMeasurement());
    dispatch(
      isEpisodeMeasurementActive
        ? trackStopEpisodeMeasurement('click')
        : trackEpisodeMeasurement(),
    );
    dispatch(
      setActiveTool({
        tool: isEpisodeMeasurementActive ? null : Tool.episodeMeasurement,
        meta: { history: false },
      }),
    );
  };
  return (
    <ToolButton
      label='Measure Episode Duration'
      onClick={activateEpisodeMeasurement}
      aria-label='Measure Episode Duration'
      icon={<MeasureEpisodeIcon />}
      isDisabled={isParentHolterView}
      isActive={isEpisodeMeasurementActive}
    />
  );
};
